/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Redirect, useHistory, useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { appVersion, googleClientId, loginUrl } from '../../components/Helpers/Config';
import GoogleLogin from 'react-google-login';
import GoogleLogo from '../../common/images/google_logo.png';
import NIELogo from '../../common/images-new/nie-login-logo.jpg';

import { serverUrl } from '../../components/Helpers/Config';
import { loadUserPublic } from '../../redux/actions/auth';

import { USER_PUBLIC_LOADING, LOGIN_GUEST_SUCCESS, AUTHENTICATION_PUBLIC_FAILED } from '../../redux/actions/auth';
import axios from 'axios';
import { staticFiles } from '../../components/Helpers/Static';
import ButtonBlue from '../../components/Button/ButtonBlue';
import jwtDecode from 'jwt-decode';
import { tokenAuthorize } from '../../components/Helpers/Common';
import { GET_THEME_LOADER } from '../../redux/actions/auth';

const LOADING_GIF = staticFiles.loading;

const GuestPublicLogin = ({ ...props }) => {
	const dispatch = useDispatch();
	const location = useLocation();
	const history = useHistory();
	const sharedCode = props.match.params.sharedCode;
	const [errorMessage, setErrorMessage] = useState('');
	const [inputPass, setInputPass] = useState('')
	const [decodedData, setDecodedData] = useState({})

	const isLoading = useSelector(state => state.auth.isPublicLoading)
	const publicTokens = useSelector(state => state.auth.publicTokens)

	const handleLogin = async () => {
		dispatch({ type: USER_PUBLIC_LOADING })
		return axios.post(
			serverUrl.LoginGuest,
			{ link: sharedCode?.split('?')[0], password: inputPass }
		).then(resp => {
			if (resp.status === 200) {
				const token = resp.data.token
				const decoded = jwtDecode(token)

				setDecodedData(decoded)
				dispatch({ type: LOGIN_GUEST_SUCCESS, data: decoded, token: token });
				history.push(`/public/${sharedCode}`)
			}
		}).catch(err => {
			tokenAuthorize(err?.response?.status);
			if (err.response && (err.response.status === 401)) {
				setErrorMessage('User not registered')
			}
			else setErrorMessage('Invalid login')

			dispatch({
				type: AUTHENTICATION_PUBLIC_FAILED,
				data: sharedCode?.split('?')[0],
				error: ['Login error']
			});
		});
	}

	useEffect(() => {
		const token = localStorage.getItem("dp2_token_access_" + sharedCode?.split('?')[0]);
		if (token) {
			dispatch(loadUserPublic(sharedCode?.split('?')[0]));
			history.push(`/public/${sharedCode}`)
		}
		else{
			dispatch({ type: GET_THEME_LOADER, payload: false });
		}
	}, [])

	const handleKeypress = e => {
		//it triggers by pressing the enter key
		if (e.key === 'Enter') {
			e.preventDefault()
			handleLogin()
		}
	};

	return (
		<div className='flex flex-col gap-2 justify-center items-center bg-login p-5 min-h-screen'>
			<div className='bg-white rounded-2xl flex flex-col items-center p-8  max-w-xl'>
				<img src={NIELogo} alt='NIE Logo' className='img-300' />
				<h1 className='text-black font-bold text-xl sm:text-2xl text-center'>Welcome to Digital Portfolio</h1>
				<div className='w-full mt-5 mb-3'>
					<label className='flex text-black font-normal mb-3'>
						Enter Password
					</label>
					<input
						type="password"
						placeholder='Password'
						className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm 
		 focus:outline-none focus:ring-2 focus:ring-blue-custom focus:border-blue-custom 
		 text-lg font-medium"
						value={inputPass}
						onChange={(e) => setInputPass(e.target.value)}
						onKeyPress={handleKeypress}
					/>


				</div>
				{
					isLoading ?
						<div className='w-full flex flex-col items-center mt-4'>
							<img src={LOADING_GIF} alt='' className='w-10 h-10' />
							<p>Loading...</p>
						</div>
						:
						<>
							{
								(errorMessage && (errorMessage.length > 0)) &&
								<div className='w-full flex flex-col mb-4 text-red-600'>
									{
										(Array.isArray(errorMessage)) ? errorMessage.map(msg => msg) : errorMessage
									}
								</div>
							}


							<button onClick={handleLogin} className='text-white font-semibold bg-blue rounded-lg px-6 py-3 block w-full text-center  cursor-pointer'>Login</button>
						</>
				}

				<div className='w-full mt-4 grid grid-cols-1 place-content-end'>

					<div className='border-t mb-4 w-full place-self-center' />

					<p className='text-black md:text-sm text-xs text-center'>
						&copy; {new Date().getFullYear()} National Institute of Education Singapore. All rights reserved.<br></br>
					</p>
				</div>
			</div>

		</div>
	)
}

export default GuestPublicLogin;
// /* eslint-disable */
// import React, { useState, useEffect } from 'react';
// import { Redirect, useHistory, useLocation, useParams } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { appVersion, googleClientId, loginUrl } from '../../components/Helpers/Config';
// import GoogleLogin from 'react-google-login';
// import GoogleLogo from '../../common/images/google_logo.png';
// import NIELogo from '../../common/images-new/nie-login-logo.jpg';

// import { serverUrl } from '../../components/Helpers/Config';
// import { loadUserPublic } from '../../redux/actions/auth';

// import { USER_PUBLIC_LOADING, LOGIN_GUEST_SUCCESS, AUTHENTICATION_PUBLIC_FAILED } from '../../redux/actions/auth';
// import axios from 'axios';
// import { staticFiles } from '../../components/Helpers/Static';
// import ButtonBlue from '../../components/Button/ButtonBlue';
// import jwtDecode from 'jwt-decode';
// import { tokenAuthorize } from '../../components/Helpers/Common';

// const LOADING_GIF = staticFiles.loading;

// const GuestPublicLogin = ({ ...props }) => {
// 	const dispatch = useDispatch();
// 	const location = useLocation();
// 	const history = useHistory();
// 	const sharedCode = props.match.params.sharedCode;
// 	const [errorMessage, setErrorMessage] = useState('');
// 	const [inputPass, setInputPass] = useState('')
// 	const [decodedData, setDecodedData] = useState({})

// 	const isLoading = useSelector(state => state.auth.isPublicLoading)
// 	const publicTokens = useSelector(state => state.auth.publicTokens)

// 	const handleLogin = async () => {
// 		dispatch({ type: USER_PUBLIC_LOADING })
// 		return axios.post(
// 			serverUrl.LoginGuest,
// 			{ link: sharedCode?.split('?')[0], password: inputPass }
// 		).then(resp => {
// 			if (resp.status === 200) {
// 				const token = resp.data.token
// 				const decoded = jwtDecode(token)

// 				setDecodedData(decoded)
// 				dispatch({ type: LOGIN_GUEST_SUCCESS, data: decoded, token: token });
// 				history.push(`/public/${sharedCode}`)
// 			}
// 		}).catch(err => {
// 			tokenAuthorize(err?.response?.status);
// 			if (err.response && (err.response.status === 401)) {
// 				setErrorMessage('User not registered')
// 			}
// 			else setErrorMessage('Invalid login')

// 			dispatch({
// 				type: AUTHENTICATION_PUBLIC_FAILED,
// 				data: sharedCode?.split('?')[0],
// 				error: ['Login error']
// 			});
// 		});
// 	}

// 	useEffect(() => {
// 		const token = localStorage.getItem("dp2_token_access_" + sharedCode?.split('?')[0]);
// 		if (token) {
// 			dispatch(loadUserPublic(sharedCode?.split('?')[0]));
// 			history.push(`/public/${sharedCode}`)
// 		}
// 	}, [])

// 	const handleKeypress = e => {
// 		//it triggers by pressing the enter key
// 		if (e.key === 'Enter') {
// 			e.preventDefault()
// 			handleLogin()
// 		}
// 	};

// 	return (
// 		<div className='md:flex h-screen'>
// 			<div className='h-1/3 md:h-full md:w-5/12 grid slider content-center'>
// 				<div className='py-5 my-3 bg-white h-full flex justify-center items-center'>
// 					<img src={NIELogo} alt='nie logo' className='place-self-center w-6/12' />
// 				</div>
// 			</div>
// 			<div className='h-2/3 md:h-full md:w-7/12'>
// 				<div className='h-5/6 grid'>
// 					<div className='place-self-center'>
// 						<h1 className='text-black font-bold text-2xl'>Welcome to Digital Portfolio</h1>
// 						<div className='mt-10 mb-3'>
// 							<label className='flex text-black font-normal mb-3'>
// 								Enter Password
// 							</label>
// 							<input
// 								type="password"
// 								placeholder='Password'
// 								className='border-2 border-inherit pl-2 py-3 w-full'
// 								value={inputPass}
// 								onChange={(e) => setInputPass(e.target.value)}
// 								onKeyPress={handleKeypress}
// 							/>


// 						</div>
// 						{
// 							isLoading ?
// 								<div className='w-full flex flex-col items-center mt-4'>
// 									<img src={LOADING_GIF} alt='' className='w-10 h-10' />
// 									<p>Loading...</p>
// 								</div>
// 								:
// 								<>
// 									{
// 										(errorMessage && (errorMessage.length > 0)) &&
// 										<div className='w-full flex flex-col mb-4 text-red-600'>
// 											{
// 												(Array.isArray(errorMessage)) ? errorMessage.map(msg => msg) : errorMessage
// 											}
// 										</div>
// 									}

// 									<ButtonBlue bgColor={"bg-blue text-white"} title='LOGIN' width='full' onClick={handleLogin} />

// 								</>
// 						}
// 					</div>
// 				</div>
// 				<div className='h-1/6 grid gap-2 grid-cols-1 place-content-end'>
// 					<div className='border-t md:w-4/5 mb-4 w-full place-self-center' />
// 					<p className='text-black md:text-sm text-xs text-center'>{appVersion}</p>
// 					<p className='text-black md:text-sm mb-2 text-xs text-center'>
// 						&copy; {new Date().getFullYear()} National Institute of Education Singapore. All rights reserved.<br></br>
// 						<span class="text-center text-gray-600 footerVersionText">{process.env.REACT_APP_DP4_VERSION}</span>
// 					</p>
// 				</div>
// 			</div>
// 		</div>
// 	)
// }

// export default GuestPublicLogin;